import React from "react";
import { useTranslation } from "react-i18next";

import "../styles/SelectActualCyclists.css";

const SelectCyclists = ({
  numberPlayerSelected,
  setNumberPlayerSelected,
  selectedCyclists,
  selectedActualCyclists,
  setSelectedActualCyclists,
  budget,
  setBudget,
  nextStep,
}) => {
  const { t } = useTranslation();

  const handleSelectCyclist = (cyclist) => {
    if (selectedActualCyclists.some((selected) => selected.cyclistId === cyclist.cyclistId)) {
      setSelectedActualCyclists(
        selectedActualCyclists.filter((selected) => selected.cyclistId !== cyclist.cyclistId)
      );
      setNumberPlayerSelected(numberPlayerSelected - 1);
      setBudget(budget - cyclist.finalValue);
    } else {
      setSelectedActualCyclists([...selectedActualCyclists, cyclist]);
      setNumberPlayerSelected(numberPlayerSelected + 1);
      setBudget(budget + cyclist.finalValue);
    }
  };

  const isCyclistsSelected = (cyclistId) => {
    return selectedActualCyclists.some((selected) => selected.cyclistId === cyclistId);
  };

  const isButtonDisabled = selectedActualCyclists.length > 4;

  return (
    <main className="select-actual-cyclists">
      <div className="select-actual-cyclists-shadow-container">
        <div className="select-actual-cyclists-title">
          <h1>{t("selectActualCyclists.title")}</h1>
          <div className="select-actual-cyclists-shadow-mask-right"></div>
          <div className="select-actual-cyclists-shadow-mask-bottom"></div>
        </div>
      </div>

      <div className="select-actual-cyclists-header">
        <div className="select-actual-cyclists-rules">
          <p>{t("selectActualCyclists.rules")}</p>
        </div>

        <div className="select-actual-cyclists-change-step">
          <button onClick={nextStep} disabled={isButtonDisabled}>
            {t("common.validate")}
          </button>
        </div>
      </div>

      <div className="select-actual-cyclists-pannel-view">
        <div className="select-actual-cyclists-choice">
          <div className="select-actual-cyclists-table-container">
            <table>
              <thead>
                <tr>
                  <th>{t("cyclists.table.cyclist")}</th>
                  <th>{t("cyclists.table.team")}</th>
                  <th>{t("cyclists.table.nation")}</th>
                  <th>{t("cyclists.table.value")}</th>
                  <th>{t("cyclists.table.speciality")}</th>
                </tr>
              </thead>

              <tbody>
                {selectedCyclists.map((cyclist) => (
                  <tr
                    key={cyclist.cyclistId}
                    onClick={() => handleSelectCyclist(cyclist)}
                    className={
                      isCyclistsSelected(cyclist.cyclistId)
                        ? "select-actual-cyclists-table-selected-row"
                        : ""
                    }
                  >
                    <td>
                      <div className="select-actual-cyclists-name-info">
                        <img
                          className="select-actual-cyclists-flag-icon"
                          src={`${process.env.PUBLIC_URL}/flags/${cyclist.nationality
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .replace(/ /g, "_")
                            .toLowerCase()}.png`}
                          alt={t("common.flagAlt", { country: cyclist.nationality })}
                          width="20"
                          height="20"
                        />
                        <span>{cyclist.name}</span>
                      </div>
                    </td>
                    <td>{cyclist.team}</td>
                    <td>{cyclist.nationality}</td>
                    <td>{cyclist.finalValue}</td>
                    <td>{cyclist.speciality}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="select-actual-cyclists-warning">
            <p>
              <strong>{t("common.attention")}</strong>
              <br />
              {t("selectActualCyclists.warning")}
            </p>
          </div>
        </div>

        <div className="select-actual-cyclists-line-container">
          {selectedActualCyclists.map((cyclist) => (
            <div className="select-actual-cyclists-selected-cell" key={cyclist.cyclistId}>
              <div className="select-actual-cyclists-selected-info">
                <img
                  src={`${process.env.PUBLIC_URL}/icons/cancel.png`}
                  className="select-actual-cyclists-cancel-icon"
                  alt={t("common.removeIconAlt")}
                  width="17"
                  height="17"
                  onClick={() => handleSelectCyclist(cyclist)}
                />
                <h4>
                  <img
                    className="select-actual-cyclists-flag-icon"
                    src={`${process.env.PUBLIC_URL}/flags/${cyclist.nationality
                      .replace(/ /g, "_")
                      .toLowerCase()}.png`}
                    alt={t("common.flagAlt", { country: cyclist.nationality })}
                    width="20"
                    height="20"
                  />
                  {cyclist.name}
                </h4>
                <p>{cyclist.team}</p>
                <p>
                  {t("cyclists.valueLabel")} : <strong>{cyclist.finalValue}</strong>
                </p>
                <div
                  style={{
                    width: "100%",
                    height: "15px",
                    backgroundColor: cyclist.teamColor,
                    marginTop: "35px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                ></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </main>
  );
};

export default SelectCyclists;
